import {
	useNativeKeyboard,
	KeyboardResize,
	KeyboardStyle,
} from '/src/native/useNativeKeyboard.js';

import { useDark } from '/src/composables/useDark.js';
import { watchEffect } from 'vue';

const isDark = useDark();
const {
	setResizeMode,
	setStyle,
} = useNativeKeyboard();

export function useKeyboardService () {
	let stopEffect;

	async function start () {
		stop();

		setResizeMode({ mode: KeyboardResize.None });

		stopEffect = watchEffect(() => {
			const style = !isDark.value ? 'Light' : 'Dark';
			setStyle({ style: KeyboardStyle[style] });
		});
	}

	function stop () {
		if (stopEffect) {
			stopEffect();
			stopEffect = null;
		}
	}

	return {
		start,
		stop,
	};
}
